import React from "react";
import "./divider.scss";
import classNames from "classnames";

interface IProps {
  position: "horizontal" | "vertical";
  colour: "secondary" | "primary" | "light-blue" | "blue" | "light-gray" | "gray";
  thickness?: number | undefined;
  height?: number | undefined;
  width?: number | undefined;
  auto?: boolean;
  center?: boolean;
}

export default function Divider(props: IProps) {
  const { position, colour, thickness, width, height, auto, center } = props;

  return (
    <div
      style={{
        borderWidth: thickness && `${thickness}px`,
        width: auto ? "auto" : width && `${width}px`,
        height: auto ? "auto" : height && `${height}px`,
      }}
      className={classNames("divider", {
        [`divider-${position}`]: position,
        [`divider-${colour}`]: colour,
        [`divider-center`]: center,
      })}
    ></div>
  );
}
